import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";
import type { ColorProfileTheme } from "aviary-tokens/dist/types";

import { dimensions, helpers, timing } from "@styles";

export const base = css`
  ${helpers.fontSizeNormalizer(16)};
  border-radius: ${dimensions.pillBorderRadius};
  text-align: center;
  font-weight: ${typography.weightSemiBold};
  padding: 0 0.5rem;
  min-width: 2rem;
  display: flex;
  align-items: center;
`;

export const respectMobile = (textLength: number) => css`
  display: ${textLength >= 40 ? "flex" : "inline-flex"};
  margin-left: ${textLength >= 40 ? "0" : "1rem"};
  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    margin-left: 0;
    display: flex;
  }
`;

export const lightPill = (theme: Theme) => css`
  color: ${theme.light.textBase};
  background-color: ${theme.light.backgroundBase};
  border-color: transparent;

  path.fa-spinner-third {
    fill: ${theme.light.textBase};
  }
`;

export const size = {
  small: css`
    ${helpers.fontSizeNormalizer(14)}
    padding: 0.125rem 0.5rem;
  `,
  large: css`
    ${helpers.fontSizeNormalizer(20)}
    padding: 0.125rem 0.5rem;
  `,
};

export const icon = {
  start: css`
    margin-left: 0;
    margin-right: 0.5rem;
  `,
  end: css`
    margin-left: 0.5rem;
    margin-right: 0;
  `,
};

export const themedStyles = (theme: ColorProfileTheme) => css`
  color: ${theme.textHover};
  background-color: ${theme.backgroundMuted};
  border-color: transparent;

  path.fa-spinner-third {
    fill: ${theme.textBase};
  }
`;

export const loader = css`
  margin-right: 0.5rem;

  svg {
    animation-duration: ${timing.slow};
  }
`;

export const disabled = (theme: Theme) => css`
  color: ${theme.disabled.text};
  background-color: ${theme.disabled.nakedContent};

  &&&:hover {
    cursor: not-allowed;
  }
`;
